import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { Popover } from './popover';
import { ArrowContentContainer } from './content-containers/arrow';
import type { IDeps, TPopover } from './models';

export const ArrowPopover = createWidget<IDeps, TPopover>({
    ContentContainer: ArrowContentContainer,
})(Popover);
